import React, { HTMLProps } from 'react';
import classnames from 'classnames';

type SearchPopoverItemProps = HTMLProps<HTMLDivElement> & {
  className?: string;
};

const SearchPopoverHeading: React.FC<SearchPopoverItemProps>  = ({
  className,
  ...props
}) => {
  const itemStyle = classnames(
    "flex items-center justify-between px-3 py-2 text-sm font-medium bg-light-0 text-light-900", className
  );

  return (
    <div
      className={itemStyle}
      {...props}
    />
  )
}

export default SearchPopoverHeading;
